__turbopack_context__.v({
  "action": "portable-secret-module-scss-module__JL9sBG__action",
  "container": "portable-secret-module-scss-module__JL9sBG__container",
  "details": "portable-secret-module-scss-module__JL9sBG__details",
  "generate-password": "portable-secret-module-scss-module__JL9sBG__generate-password",
  "generate-password-container": "portable-secret-module-scss-module__JL9sBG__generate-password-container",
  "outlined-input": "portable-secret-module-scss-module__JL9sBG__outlined-input",
  "password": "portable-secret-module-scss-module__JL9sBG__password",
  "password-hint": "portable-secret-module-scss-module__JL9sBG__password-hint",
  "password-input": "portable-secret-module-scss-module__JL9sBG__password-input",
  "password-input-container": "portable-secret-module-scss-module__JL9sBG__password-input-container",
  "secret-type-form": "portable-secret-module-scss-module__JL9sBG__secret-type-form",
  "settings": "portable-secret-module-scss-module__JL9sBG__settings",
  "show-password": "portable-secret-module-scss-module__JL9sBG__show-password",
});
